import { connect } from 'react-redux';
import SearchMenu from './search-menu.component';

const mapStateToProps = ({ player }) => ({
  activeTheme: player.ebookData.activeTheme,
  queue: player.queue,
  activeIndex: player.activeIndex,
});

export default connect(mapStateToProps)(SearchMenu);
